import GiveHelp from "../Components/GiveHelp/giveHelp";

//this is importing a component into a giveHelp page
export default function GiveHelpPage() {
    return <GiveHelp/>

}